export default {
    config:'index',
    logout:'logout'
}